var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tippy",
          rawName: "v-tippy",
          value: { followCursor: true, placement: "bottom-end" },
          expression: "{ followCursor: true, placement: 'bottom-end' }",
        },
      ],
      staticClass: "code-input",
      class: { disabled: _vm.disabled },
      attrs: { content: _vm.$t("message.toActivatePlanNeedOthers") },
    },
    [
      _c("a-input", {
        attrs: { disabled: _vm.disabled },
        model: {
          value: _vm.cloneValue,
          callback: function ($$v) {
            _vm.cloneValue = $$v
          },
          expression: "cloneValue",
        },
      }),
      _vm._v(" "),
      !_vm.disabled
        ? _c(
            "div",
            { staticClass: "confirm-code", on: { click: _vm.confirm } },
            [_c("div", { staticClass: "material-icons" }, [_vm._v("check")])]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }